// A lasting, inline explanation of why the server refused a user's action.
//
// A toast is gone in four seconds and is easy to miss — especially behind a
// dialog the user is still looking at. When a save is REFUSED (a 4xx with the
// service's own words, e.g. "This SFTP host can't be reached from KaziPeople —
// it must be a public address."), the reason must stay next to the form until
// the user changes something, retries, or dismisses it. Pass the message from
// getApiErrorMessage(e, fallback); null renders nothing.
import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

export interface ActionRefusalProps {
  message: string | null | undefined;
  onDismiss?: () => void;
  testId?: string;
  className?: string;
}

export const ActionRefusal: React.FC<ActionRefusalProps> = ({ message, onDismiss, testId, className }) => {
  if (!message) return null;
  return (
    <div
      role="alert"
      aria-live="assertive"
      data-testid={testId}
      className={`flex items-start gap-2 rounded-md bg-danger-soft p-3 text-sm text-danger-strong ${className ?? ''}`}
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <p className="flex-1 break-words">{message}</p>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss"
          className="rounded p-0.5 hover:bg-background/40"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
};

export default ActionRefusal;
